// src/components/TimestampBadge.js
import React from "react";

const formatTs = (ts) => {
    if (!ts) return "";
    // supports numbers, Date, and Firestore Timestamp-like (toDate)
    if (typeof ts === "number") return new Date(ts).toLocaleString();
    if (ts?.toDate) return ts.toDate().toLocaleString();
    if (ts instanceof Date) return ts.toLocaleString();
    return String(ts);
};

export default function TimestampBadge({
                                           mode = "none",         // 'none' | 'created' | 'updated' | 'both'
                                           createdAt,
                                           updatedAt,
                                           className = "",
                                           style = {},
                                       }) {
    if (mode === "none") return null;

    const parts = [];
    if (mode === "created" || mode === "both") parts.push(`Created: ${formatTs(createdAt)}`);
    if (mode === "updated" || mode === "both") parts.push(`Updated: ${formatTs(updatedAt)}`);

    return (
        <div
            className={className}
            style={{ marginTop: 8, fontSize: "0.8rem", opacity: 0.75, ...style }}
        >
            {parts.join(" • ")}
        </div>
    );
}
